import http from '../_httpHandlers';
import { config } from '../_config';
import { IUpdateComponent, IComponent } from '../_types/interfaces';

const uri = config.backendAddress;

const getAddress = async (): Promise<string> => {
    return await http.get(`${uri}/ServerAddress`, "text");
};

const getServices = async (uriService: string): Promise<Array<IComponent>> => {
    return await http.get(`${uriService}/GetServices`);
};


const getInstallServices = async (): Promise<Array<IComponent>> => {
    return await http.get(`${uri}/GetInstallService`);
};

const getPlugins = async (uriService: string): Promise<Array<IComponent>> => {
    return await http.get(`${uriService}/GetPlugins`);
};

const getInstallPlugins = async (): Promise<Array<IComponent>> => {
    return await http.get(`${uri}/GetInstallPlugin`);
};

const updateServices = async (services: Array<string>): Promise<void> => {
    return await http.post(`${uri}/AddComponents`, services, 'none');
};

const deleteServices = async (services: Array<string>): Promise<void> => {
    return await http.post(`${uri}/DeleteComponents`, services, 'none');
};


export const updateService: IUpdateComponent = {
    getAddress,
    getServices,
    getInstallServices,
    getInstallPlugins,
    getPlugins,
    updateServices,
    deleteServices,
};